// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"Uploader_dropzone__3PVvF","active":"Uploader_active__13oOx"};